module.exports = __webpack_public_path__ + "img/icon-confirm-outline.dba5a9f6.svg";